import storageAvailable from '../storage_available';

interface GtmDataObject {}

export default function pushToLocalGtmQueue(gtmEvent: GtmDataObject) {
  if (storageAvailable('localStorage')) {
    const storedQueue = localStorage.getItem('gtm-queue');
    const queue: Array<GtmDataObject> = Array.isArray(storedQueue)
      ? storedQueue
      : [];
    queue.push(gtmEvent);
    return localStorage.setItem('gtm-queue', JSON.stringify(queue));
  }
  return false;
}
